// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import TiposServicios from '../../components/administration/servicesTypes/ServicesTypesDashboard';

const TiposServiciosPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <TiposServicios
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de tipos de servicios:', newOrder);
                }}
            />
        </Box>
    );
};

export default TiposServiciosPage;
